export class ToolRequestStatus {
    static NEW = "New";
    static WAITING_FOR_APPROVAL = "WaitingForApproval";
    static APPROVED = "Approved";
    static REJECTED = "Rejected";
    static WAITING_FOR_PROCESSING = "WaitingForProcessing";
    static PROCESSED = "Processed";
    static DELIVERED = "Delivered";
    static IN_TRANSPORT = "InTransport";
    static CONFIRMED = "Confirmed";
    static WAITING_FOR_CONFIRMATION = "WaitingForConfirmation";
    static CLOSED = "Closed";
    static CANCELED = "Canceled";
}
